module.exports = __webpack_public_path__ + "static/media/19ESCAP44.2d2b10b6.jpg";